export default function FWCredits() {
  return <>
    <br/><br/>
    <b>Thanks to:</b><br/>
    - <a href="https://myamazfit.ru/members/mixann.49882/">Mixann</a> for 1.1.5.36 FW<br/>
    - Taha Nafis for b7 1.1.2.05 FW<br/>
  </>;
}